module.exports = __webpack_public_path__ + "img/生殖系统-.988b4a93.png";